import { getJurisdictionSurvey,getDriverCarRate,getDeviceDismantle,getCarEmissionRate,getSafetyDeviceRate,getCarAgeRate,getCarMaintainRate,getCheckRate,getSpotCheckAbnormalRate } from "../../api/config/modules/JurisdictionalAnalysis";

const state = {
    getJurisdictionSurvey: {},
    getDriverCarRate: {},
    getDeviceDismantle: {},
    getCarEmissionRate: {},
    getSafetyDeviceRate: {},
    getCarAgeRate: {},
    getCarMaintainRate: {},
    getCheckRate: {},
    getSpotCheckAbnormalRate: {}
};

const mutations = {
    SET_GETJURISDICTIONSURVEY: (state, getJurisdictionSurvey) => {
        state.getJurisdictionSurvey = getJurisdictionSurvey;
    },
    SET_GETDRIVERCARRATE: (state, getDriverCarRate) => {
        state.getDriverCarRate = getDriverCarRate;
    },
    SET_GETDEVICEDISMANTLE: (state, getDeviceDismantle) => {
        state.getDeviceDismantle = getDeviceDismantle;
    },
    SET_GETCAREMISSIONRATE: (state, getCarEmissionRate) => {
        state.getCarEmissionRate = getCarEmissionRate;
    },
    SET_GETSAFETYDEVICERATE: (state, getSafetyDeviceRate) => {
        state.getSafetyDeviceRate = getSafetyDeviceRate;
    },
    SET_GETCARAGERATE: (state, getCarAgeRate) => {
        state.getCarAgeRate = getCarAgeRate;
    },
    SET_GETCARMAINTAINRATE: (state, getCarMaintainRate) => {
        state.getCarMaintainRate = getCarMaintainRate;
    },
    SET_GETCHECKRATE: (state, getCheckRate) => {
        state.getCheckRate = getCheckRate;
    },
    SET_GETSPOTCHECKABNORMALRATE: (state, getSpotCheckAbnormalRate) => {
        state.getSpotCheckAbnormalRate = getSpotCheckAbnormalRate;
    },
};

const actions = {
    GET_GETJURISDICTIONSURVEY: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            getJurisdictionSurvey(data)
                .then((res) => {
                    commit("SET_GETJURISDICTIONSURVEY", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_GETDRIVERCARRATE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            getDriverCarRate(data)
                .then((res) => {
                    commit("SET_GETDRIVERCARRATE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_GETDEVICEDISMANTLE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            getDeviceDismantle(data)
                .then((res) => {
                    commit("SET_GETDEVICEDISMANTLE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_GETCAREMISSIONRATE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            getCarEmissionRate(data)
                .then((res) => {
                    commit("SET_GETCAREMISSIONRATE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_GETSAFETYDEVICERATE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            getSafetyDeviceRate(data)
                .then((res) => {
                    commit("SET_GETSAFETYDEVICERATE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_GETCARAGERATE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            getCarAgeRate(data)
                .then((res) => {
                    commit("SET_GETCARAGERATE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_GETCARMAINTAINRATE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            getCarMaintainRate(data)
                .then((res) => {
                    commit("SET_GETCARMAINTAINRATE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_GETCHECKRATE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            getCheckRate(data)
                .then((res) => {
                    commit("SET_GETCHECKRATE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_GETSPOTCHECKABNORMALRATE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            getSpotCheckAbnormalRate(data)
                .then((res) => {
                    commit("SET_GETSPOTCHECKABNORMALRATE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
